const getRoot = (root) => typeof root === "string" ? document.querySelector(root) : root;
export {
  getRoot
};
